import { IReduxStore } from "Redux/Store/IReduxStore";
import { MealCategory } from "Domain/Model/MealCategory/MealCategory";

export const getMealCategory = (state: IReduxStore, id: string): MealCategory => state.mealCategory.mealCategory.entries[id];
